export const useCustomLayout = () => {
  const hostname = window.location.hostname;

  try {
    const raw = localStorage.getItem('user');
    const data = JSON.parse(raw);
    const extId = Number(data?.ext_headoffice_id);
    return hostname === 'lk.ecvi.ru' && extId === 21;
    //  hostname === 'lk.ecvi.ru' && extId === 21; 

  } catch (e) {
    console.error('Ошибка парсинга localStorage', e);
    return false;
  }
};